import { render } from "./CardsLivingAme.vue?vue&type=template&id=938d456c"
import script from "./CardsLivingAme.vue?vue&type=script&lang=js"
export * from "./CardsLivingAme.vue?vue&type=script&lang=js"

import "./CardsLivingAme.vue?vue&type=style&index=0&id=938d456c&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__